import { ProfileData } from 'interfaces/authentication';
import { TProfitBoostItem } from 'interfaces/bet-data';
import type { TCheckProfitBoostPayload } from 'newelements/_Betslip/managers/ProfitBoostManager/actions';
import store from 'store';

type TBuildProfitBoostDataFromFreeBetResponse = (
  data: TCheckProfitBoostPayload['data']
) => TProfitBoostItem[];

export const buildProfitBoostDataFromFreeBetResponse: TBuildProfitBoostDataFromFreeBetResponse =
  freeBetResponse => {
    const { currency }: ProfileData = store.getState().userData.user;

    return freeBetResponse.reduce<TProfitBoostItem[]>(
      (items, item) =>
        item.amount_percent
          ? [
              ...items,
              {
                ...item,
                boost_max_bet_amounts: item.boost_max_bet_amounts
                  ? item.boost_max_bet_amounts.find(
                      amount => amount.Currency === currency
                    )
                  : null,
                amount_percent: item.amount_percent
              }
            ]
          : items,
      []
    );
  };
